import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Label, Input, Row, Col } from 'reactstrap';
import CustomSelect from '../../../Base/Common/CustomSelect';
import { isSafeImageUrl, getBindingSelectOptions, LOGO_BINDING } from '../templateUtils';
import HotelImagePicker from './HotelImagePicker';

class ImageInspector extends Component {
    _update = (field, value) => {
        const { element, onChange } = this.props;
        onChange({ ...element, [field]: value });
    };

    // A dynamic image replaces the fixed URL (src wins on print); the logo starts shown only when the voucher type has one
    _updateBinding = (binding) => {
        const { element, onChange } = this.props;
        const next = { ...element, binding };
        if (binding) next.src = '';
        if (binding === LOGO_BINDING && !element.visibleWhen) next.visibleWhen = 'HasLogo';
        onChange(next);
    };

    render() {
        const { element } = this.props;

        const bindingOptions = [
            { value: null, label: '— URL —' },
            ...getBindingSelectOptions('image', element.binding),
        ];

        return (
            <div>
                <Row className="mb-2">
                    <Col>
                        <Label className="mb-1 font-weight-bold" style={{ fontSize: '0.8rem' }}>
                            <FormattedMessage id="TemplateDesigner.Inspector.Binding" />
                        </Label>
                        <CustomSelect
                            options={bindingOptions}
                            value={bindingOptions.find(o => o.value === element.binding) || bindingOptions[0]}
                            onChange={(opt) => this._updateBinding(opt ? opt.value : null)}
                        />
                    </Col>
                </Row>

                {!element.binding && (
                    <Row className="mb-2">
                        <Col>
                            <Label className="mb-1 font-weight-bold" style={{ fontSize: '0.8rem' }}>
                                <FormattedMessage id="TemplateDesigner.Inspector.ImageUrl" />
                            </Label>
                            <Input
                                type="text"
                                name="src"
                                value={element.src || ''}
                                placeholder="https://..."
                                onChange={(e) => this._update('src', e.target.value)}
                            />
                        </Col>
                    </Row>
                )}

                {/* Hotel-image picker (additional convenience to the URL field) */}
                {!element.binding && (
                    <Row className="mb-2">
                        <Col>
                            <HotelImagePicker onSelect={(url) => this._update('src', url)} />
                        </Col>
                    </Row>
                )}

                {!element.binding && isSafeImageUrl(element.src) && (
                    <Row className="mb-2">
                        <Col>
                            <img
                                src={element.src}
                                alt="preview"
                                style={{ maxWidth: '100%', maxHeight: 80, objectFit: 'contain', border: '1px solid #dee2e6', borderRadius: 4 }}
                            />
                        </Col>
                    </Row>
                )}

                <Row className="mb-2">
                    <Col>
                        <Label className="mb-1 font-weight-bold" style={{ fontSize: '0.8rem' }}>
                            <FormattedMessage id="TemplateDesigner.Inspector.Margin" />
                        </Label>
                        <Input
                            type="number"
                            min={0}
                            max={50}
                            value={element.margin ?? 0}
                            onChange={(e) => this._update('margin', parseFloat(e.target.value) || 0)}
                        />
                    </Col>
                    <Col>
                        <Label className="mb-1 font-weight-bold" style={{ fontSize: '0.8rem' }}>
                            <FormattedMessage id="TemplateDesigner.Inspector.Opacity" />
                        </Label>
                        <Input
                            type="number"
                            min={0}
                            max={100}
                            value={element.opacity ?? 100}
                            onChange={(e) => this._update('opacity', Math.max(0, Math.min(100, parseInt(e.target.value, 10) || 0)))}
                        />
                    </Col>
                </Row>

                <Row className="mb-2">
                    <Col>
                        <Label className="mb-1 font-weight-bold" style={{ fontSize: '0.8rem' }}>
                            <FormattedMessage id="TemplateDesigner.Inspector.ImageFit" />
                        </Label>
                        <Input
                            type="select"
                            value={element.fit || 'contain'}
                            onChange={(e) => this._update('fit', e.target.value)}
                        >
                            <option value="contain">Contain</option>
                            <option value="cover">Cover</option>
                            <option value="fill">Stretch</option>
                        </Input>
                    </Col>
                </Row>

                <Row className="mb-2">
                    <Col>
                        <Label className="mb-1 font-weight-bold" style={{ fontSize: '0.8rem' }}>
                            <FormattedMessage id="TemplateDesigner.Inspector.BorderRadius" />
                        </Label>
                        <Input
                            type="number"
                            min={0}
                            max={50}
                            value={element.borderRadius ?? 0}
                            onChange={(e) => this._update('borderRadius', parseInt(e.target.value, 10) || 0)}
                        />
                    </Col>
                    <Col>
                        <Label className="mb-1 font-weight-bold" style={{ fontSize: '0.8rem' }}>
                            <FormattedMessage id="TemplateDesigner.Inspector.Shadow" />
                        </Label>
                        <Input
                            type="select"
                            value={element.shadow || 'none'}
                            onChange={(e) => this._update('shadow', e.target.value)}
                        >
                            <option value="none">None</option>
                            <option value="soft">Soft</option>
                            <option value="medium">Medium</option>
                            <option value="strong">Strong</option>
                        </Input>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default ImageInspector;
